import { FincasPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_fincas_pb";
import { GuardarConteoPayload } from "../../../shared/services/api/payload/terceros/GuardarConteoPayload";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Carga del conteo (KML de puntos) ya subido (`FincasPlataformaService.GuardarConteo`, gRPC). */
export class GuardarConteoService {
  /** Reemplaza el conteo y encola sus tiles. */
  static async guardar(payload: GuardarConteoPayload): Promise<void> {
    await grpcCall(() => grpcClient(FincasPlataformaService).guardarConteo({ fincaId: payload.fincaId, blobUrl: payload.uriConteo }));
  }
}
